import { apiRequest } from '@/lib/api-client';

export interface BudgetMeter {
  used: number;
  cap: number | null;
  remaining: number | null;
  exceeded: boolean;
}

export interface BudgetStatus {
  periodStart: string;
  currency: string;
  aiTokens: BudgetMeter;
  adSpend: BudgetMeter;
}

export interface UpdateLimitsInput {
  monthlyAiTokenCap?: number | null;
  monthlyAdSpendCap?: number | null;
}

const base = (orgId: string, projectId: string) =>
  `/api/v1/organizations/${orgId}/projects/${projectId}/guardrails`;

export const guardrailsApi = {
  get: (orgId: string, projectId: string) => apiRequest<BudgetStatus>(base(orgId, projectId)),
  update: (orgId: string, projectId: string, body: UpdateLimitsInput) =>
    apiRequest<BudgetStatus>(base(orgId, projectId), { method: 'PATCH', body }),
};
